export default __webpack_public_path__ + "static/media/James A.c7f00868.jpg";